import React, { createContext, useContext } from 'react';
import { AuthUseCase } from '../../application/use-cases/AuthUseCase';
import { ApiAuthRepository } from '../repositories/ApiAuthRepository';
import { useHttpClientCore } from '@/shared';


interface IAuthDIContext {
  authUseCase: AuthUseCase;
}
const AuthDIContext = createContext<IAuthDIContext | undefined>(undefined);

export const AuthDIProvider = ({ children }: { children: React.ReactNode }) => {
  const httpClient = useHttpClientCore();
  const authUseCase = new AuthUseCase(new ApiAuthRepository(httpClient));
  return <AuthDIContext.Provider value={{ authUseCase }}>{children}</AuthDIContext.Provider>;
};

export const useAuthDIContext = () => useContext(AuthDIContext);
